//React
import React from "react";
import {
  NavLink,
} from "react-router-dom";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


class Comp extends React.Component {
  render() {
    return (
      <div className='sub_menu' style={{maxWidth:'300px', margin:'auto'}}>
        <div className='outer'>
          <NavLink to="/favorite/my/" className='link' activeClassName="selected">
            <div className='text' style={{padding:'10px'}}>自分から</div>
          </NavLink>
          <NavLink to="/favorite/partner/" exact className='link' activeClassName="selected">
            <div className='text' style={{padding:'10px'}}>相手から</div>
            {
              (this.props.notification.favoriteNoticeUnconfirmed > 0) && (
                <span style={{position:'absolute',top:'0px',right:'0px',margin:'auto'}}>
                  <span className='badge'> </span>
                </span>
              )
            }
          </NavLink>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
	return {
    notification: state.notification,
	}
};
const mapDispatchToProps = dispatch => (
	bindActionCreators({
	}, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
